// extracted by mini-css-extract-plugin
export default {"total":"ThankYou_total__0NnCV","actions":"ThankYou_actions__wN-7w","button--alt":"ThankYou_button--alt__2LlP4","button":"ThankYou_button__F2xEp"};